import { Component, OnInit } from '@angular/core';
import {FormBuilder,Validators,FormGroup, FormControl} from '@angular/forms';
import {HttpRequestService} from './../../_services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from './../../_services/common.service';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute} from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  contactForm:FormGroup;
  contactFormSubmitStatus:boolean = false;
  pageDetails:any;
  constructor( private formBilder: FormBuilder,
		private httpServices:HttpRequestService,
    private toastr: ToastrService,
    public translate: TranslateService,
    private cService: CommonService,
    private title: Title, private meta: Meta,
    public router: Router) {
      this.cService.activelang.subscribe((lang) => {

        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang(lang);
  
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang);
      });
    }

  ngOnInit() {
    this.contactForm = this.formBilder.group({
      'first_name':['',Validators.required],
      'last_name':['',Validators.required],
      'telephone':['',Validators.required],
      'email':['',[Validators.required, Validators.email]],
      'message':['',Validators.required],
    });

  
        this.httpServices.setModule('action').post('cms_details',{"lang":"EN",
        "slug":'contact-us'}).subscribe((response) => {
					if(response.status === 'error') {
            if (response.code === 'CC-CD-0004') {
              this.router.navigate(['/page-not-found']);
            } else {
              this.toastr.error( response.data,'Error:');
            }
					} else {
            this.pageDetails = response.data;
            // console.log(this.pageDetails);
            this.title.setTitle(response.data.meta_title);
            this.meta.updateTag({ name: 'og:title', content: response.data.meta_title })
            this.meta.updateTag({ name: 'og:keyword', content: response.data.meta_keyword })
            this.meta.updateTag({ name: 'og:description', content: response.data.meta_description })
					}
				});
      

  }
  contactFormSubmitAction() {
    this.contactFormSubmitStatus = true;
    if (this.contactForm.valid) {
      let formData = this.contactForm.value;
      formData['full_name'] = formData.first_name+' '+ formData.last_name;
      this.httpServices.setModule('action').post('contact_store',formData).subscribe((response) => {

        if (response.status=='success') {
          this.translate.get([
            'THANK_YOU',
            'MESSAGE_SEND_SUCCESSFULL'
          ]).subscribe((tData)=>{
            this.resetContactForm();
            Swal.fire(tData['THANK_YOU'], tData['MESSAGE_SEND_SUCCESSFULL'], 'success');
          })
        }
        if (response.status=='error') {
          this.toastr.error( response.data,'Error:');
        }
      }, (error) => {
        console.log(error);
      });
    }
  }
  resetContactForm() {
    this.contactFormSubmitStatus = false;
    this.contactForm.reset();
  }

}
